import { createContext } from 'react'

import { type ToastAlertProps } from '../components/Instructions/Common/ToastAlert'
import { type Order } from '@consumer/graphql'

export interface ILocationUpdate {
  latitude: number
  longitude: number
}

export interface IEditAddressProps {
  clearAddressFields?: boolean
  locationUpdate?: {
    latitude: number
    longitude: number
  } | null
  useLocationUpdate?: boolean
  toggleMap?: boolean
}

export interface IAdjustGeopinToast {
  headerText: string
  bodyText: string
}

export interface IToggleMapModalToastProps {
  toastProps?: { title?: string; description?: string; status?: ToastAlertProps['status'] }
  showToastAfterClose?: boolean
}

export interface ToggleModalFuncProps {
  showModal: boolean
  auth_flow: 'instructions' | 'edit_address' | 'general' | 'permanent_address_update'
}

export interface IOverlayState {
  modalOpen: boolean
  step: number
  toggleModal: ({ showModal, auth_flow }: ToggleModalFuncProps) => void
  handleSetStep: (stepNumber: number) => void
  showMapModal: boolean
  toggleMapModal: ({ showToastAfterClose, toastProps }: IToggleMapModalToastProps) => void
  authFlow: string
  clearAddressFields: boolean
  handleClearAddressFields: (clearFields?: boolean) => void
  handleSetOrder: (order: Order) => void
  geocodeUpdate: ILocationUpdate
  handleSetGeocodeUpdate: (location: ILocationUpdate) => void
  useLocationUpdate: boolean
  setUseLocationUpdate: (useLocationUpdate: boolean) => void
  toggleEditAddress: ({ clearAddressFields, locationUpdate, useLocationUpdate, toggleMap }: IEditAddressProps) => void
  adjustGeopinToast: IAdjustGeopinToast
  handleSetAdjustGeopinToast: (toast: IAdjustGeopinToast) => void
  useUpdateNormalizedAddress: boolean
  setUseUpdateNormalizedAddress: (updateNormalizedAddress: boolean) => void
}

const defaultFn = () => {
  /* empty */
}

const defaultOverlayState = {
  modalOpen: false,
  step: 0,
  toggleModal: defaultFn,
  handleSetStep: defaultFn,
  showMapModal: false,
  toggleMapModal: defaultFn,
  authFlow: '',
  clearAddressFields: false,
  handleClearAddressFields: defaultFn,
  handleSetOrder: defaultFn,
  geocodeUpdate: { latitude: 0, longitude: 0 },
  handleSetGeocodeUpdate: defaultFn,
  useLocationUpdate: false,
  setUseLocationUpdate: defaultFn,
  toggleEditAddress: defaultFn,
  adjustGeopinToast: {
    headerText: 'Adjust Delivery Location',
    bodyText: 'Move pin on the map to update',
  },
  handleSetAdjustGeopinToast: defaultFn,
  useUpdateNormalizedAddress: false,
  setUseUpdateNormalizedAddress: defaultFn,
}

export const OverlayState = createContext<IOverlayState>(defaultOverlayState)
